import React from 'react'
import { ReactComponent } from './archive-locker.svg'
import { MergeReactElementProps } from '../types'

interface DescriptionProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', DescriptionProps>

export const Description = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return <ReactComponent stroke={color} fill="none" ref={ref} {...props} />
  }
)
